import React from 'react';
import { Stethoscope, Shield, Users, Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-white overflow-hidden pt-10 pb-12 px-4 md:pt-16 md:pb-20" data-id="element-146">
      {/* Subtle background accent */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 pointer-events-none" data-id="element-147"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-148">
        {/* Top badge */}
        

        {/* H1 Title */}
        <h1 className="font-heading md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-6 text-[24px]" data-id="element-149">
          Todo lo que necesitás saber <br className="hidden md:block" data-id="element-150" />
          <span className="text-medical-blue" data-id="element-151">antes de tu primera guardia</span>
        </h1>

        {/* Mockup image at 70% with red glow */}
        <div className="relative w-[70%] max-w-md mx-auto mb-6" data-id="element-152">
          <div className="absolute inset-0 bg-urgency-red/25 blur-3xl rounded-full transform scale-90" data-id="element-153"></div>
          <div className="relative" data-id="element-154">
            <img src="https://cdn.magicpatterns.com/uploads/hpKpjuEgBWCgfdRDd3HZN9/guardia_clinica_mockup-Photoroom.png" alt="Guardia Clínica Atlas Visual Mockup" className="w-full h-auto object-contain drop-shadow-2xl" loading="eager" data-id="element-155" />
            <div className="absolute bottom-2 right-2 bg-white/80 backdrop-blur-sm px-2 py-0.5 rounded text-[9px] font-bold text-gray-400 pointer-events-none" data-id="element-156">
              @Mundodigitalarg
            </div>
          </div>
        </div>

        {/* Subtitle */}
        <h2 className="md:text-2xl font-bold text-gray-700 mb-4 text-[14px]" data-id="element-157">
          Atlas Visual Completo — 6 Tomos + 6 Bonos Clínicos
        </h2>

        {/* Description */}
        <p className="md:text-lg text-gray-600 mb-8 max-w-2xl mx-auto text-[12px]" data-id="element-158">
          Tu sistema visual completo para enfrentar cualquier urgencia en
          guardia: ECG, cardiovascular, neurológico, shock, laboratorio y
          procedimientos. Sin improvisar frente al paciente.
        </p>

        {/* CTA */}
        <motion.a href="#pricing" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-block w-full md:w-auto bg-urgency-red text-white font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-[0_0_20px_rgba(215,38,56,0.4)] hover:bg-red-700 transition-colors animate-pulse-subtle mb-4" data-id="element-159">
          💥 QUIERO MI ATLAS AHORA
        </motion.a>

        <p className="text-sm text-gray-500 font-medium mb-8" data-id="element-160">
          PDF Digital · Acceso Inmediato · Estudiante de Medicina
        </p>

        {/* Trust Badges */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-2xl mx-auto" data-id="element-161">
          <div className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-lg border border-gray-100 w-full sm:w-auto justify-center" data-id="element-162">
            <Shield className="text-success-green" size={20} data-id="element-163" />
            <span className="text-sm font-semibold text-gray-700" data-id="element-164">
              Garantía 7 días
            </span>
          </div>
          <div className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-lg border border-gray-100 w-full sm:w-auto justify-center" data-id="element-165">
            <Users className="text-medical-blue" size={20} data-id="element-166" />
            <span className="text-sm font-semibold text-gray-700" data-id="element-167">
              +500 Estudiantes
            </span>
          </div>
          <div className="flex items-center gap-2 bg-gray-50 px-4 py-2 rounded-lg border border-gray-100 w-full sm:w-auto justify-center" data-id="element-168">
            <div className="flex text-accent-gold" data-id="element-169">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-170" />)}
            </div>
            <span className="text-sm font-semibold text-gray-700" data-id="element-171">
              4.9 Rating
            </span>
          </div>
        </div>
      </div>
    </section>;
}